<label class="cw-md-radio">
    <input type="radio" [name]="name" [checked]="checked" class="cw-md-radio__input" (click)="onRadioClick()">
    <div class="cw-md-radio__circle">
        <div class="cw-md-radio__circle__inner-circle"></div>
    </div>
    <div class="cw-md-radio__text">
        <ng-content />
    </div>
</label>
